import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../api-authorization/authorize.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isLoading = false;
  error: string | null = null;
  hide = true;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    const savedEmail = localStorage.getItem('savedEmail'); // Abrufen der gespeicherten E-Mail aus dem Local Storage
    if (savedEmail) {
      this.loginForm.patchValue({ email: savedEmail });
    }
  }

  onSubmit(): void {
    this.isLoading = true;
    this.error = null;

    if (this.loginForm.valid) {
      const loginData = this.loginForm.value;
      this.authService.login(loginData.email, loginData.password)
        .subscribe(
          (response) => {
            if (response.firstLogin) {
              this.router.navigateByUrl('changepassword'); // Leiten Sie zur Passwortänderungsseite weiter
            } else {
              this.router.navigateByUrl('/home'); // Oder zu einer anderen Zielseite nach erfolgreichem Login
            }
            localStorage.setItem('savedEmail', loginData.email); // Speichern der E-Mail im Local Storage
            this.isLoading = false;
          },
          error => {
            this.error = 'Ungültige Anmeldedaten. Bitte überprüfen Sie Ihre Eingaben.'; // Passen Sie die Fehlermeldung nach Bedarf an
            this.isLoading = false;
          }
        );
    }
  }
}
